/**
 * State-Specific Slang Suggestions for Content Studio V2
 * Bahasa Malaysia Urban Mode
 * 
 * Each state has cultural/tonal characteristics (not literal dialect words)
 * Used as AI style hints for content adaptation
 */

export const STATE_SLANG_MAP = {
  'Johor': ['Johor urban', 'JB style', 'Selatan', 'neutral BM'],
  'Melaka': ['Melaka urban', 'Selatan', 'neutral BM'],
  'Negeri Sembilan': ['Nogori urban', 'Selatan', 'neutral BM'],
  'Selangor': ['Selangor urban', 'KL-Selangor', 'neutral BM'],
  'Kuala Lumpur': ['KL urban', 'Klang Valley', 'neutral BM'],
  'Putrajaya': ['Putrajaya formal', 'Klang Valley', 'neutral BM'],
  'Perak': ['Perak mid tone', 'Utara-Tengah', 'neutral BM'],
  'Pulau Pinang': ['Penang urban', 'Utara', 'neutral BM'],
  'Kedah': ['Kedah tone', 'Utara', 'neutral BM'],
  'Perlis': ['Perlis northern', 'Utara', 'neutral BM'],
  'Kelantan': ['Kelate urban', 'Pantai Timur Klate', 'neutral BM'],
  'Terengganu': ['Ganu urban', 'Pantai Timur Ganu', 'neutral BM'],
  'Pahang': ['Pahang mid east', 'Pantai Timur', 'neutral BM'],
  'Sabah': ['Sabahan', 'Borneo', 'neutral BM'],
  'Sarawak': ['Sarawakian', 'Borneo', 'neutral BM'],
  'Labuan': ['Labuan', 'Borneo mix', 'neutral BM']
};

/**
 * Get merged and deduped slang suggestions for selected states
 * @param {string[]} selectedStates - Array of state names
 * @returns {string[]} Merged slang suggestions (max 6, deduped)
 */
export const getStateSlangSuggestions = (selectedStates) => {
  if (!selectedStates || selectedStates.length === 0) {
    return [];
  }

  const allSuggestions = selectedStates
    .filter(state => STATE_SLANG_MAP[state])
    .flatMap(state => STATE_SLANG_MAP[state]);

  // Dedupe and limit to 6
  const uniqueSuggestions = [...new Set(allSuggestions)];
  return uniqueSuggestions.slice(0, 6);
};

/**
 * Validate slang text
 * @param {string} slang - Slang text to validate
 * @returns {boolean} True if valid
 */
export const validateSlang = (slang) => {
  if (!slang || typeof slang !== 'string') return false;
  
  const trimmed = slang.trim();
  
  // Length: 2-24 characters
  if (trimmed.length < 2 || trimmed.length > 24) return false;
  
  // Pattern: alphanumeric + space + special chars [+\-\/&']
  const validPattern = /^[A-Za-z0-9 +\-\/&']+$/;
  return validPattern.test(trimmed);
};

export const MAX_SLANG_COUNT = 6;
